var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ConfigService } from '../../../service/config.service';
import { ApiService } from '../../../service/api.service';
import { FileService } from './file.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { LoadingService } from '../../../component/loading/loading.service';
var FileComponent = /** @class */ (function (_super) {
    __extends(FileComponent, _super);
    function FileComponent(service, baseService, fileService, config, api, loadingService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.fileService = fileService;
        _this.config = config;
        _this.api = api;
        _this.loadingService = loadingService;
        _this.path = '';
        _this.fileName = '';
        _this.uploadFileName = '';
        _this.displayFileName = '';
        _this.host = _this.config.config['api_base'] || '';
        return _this;
    }
    FileComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setDropzone();
    };
    FileComponent.prototype.setDropzone = function () {
        var options = (this.col.params && this.col.params.options ? this.col.params.options : {});
        var acceptedFiles = options.acceptedFiles || 'image/*';
        acceptedFiles = (acceptedFiles === '*' ? null : acceptedFiles);
        var maxFilesize = options.maxFilesize;
        this.element = this.fileElement.nativeElement;
        var self = this;
        $(this.element).dropzone({
            url: this.host + "/upload",
            headers: this.api.getCsrfToken(),
            paramName: 'file',
            parallelUploads: 1,
            maxFiles: 1,
            acceptedFiles: acceptedFiles,
            maxFilesize: maxFilesize ? maxFilesize : 1,
            addRemoveLinks: true,
            withCredentials: true,
            dictInvalidFileType: self.msg['au.COMPONENT.FileComponent.label.invalidFileType'],
            dictRemoveFile: self.msg['au.COMPONENT.FileComponent.label.removeFile'],
            params: {
                uploadType: (self.col.params && self.col.params.uploadType ? self.col.params.uploadType : null)
            },
            init: function () {
                this.on('addedfile', function (file) {
                    self.loadingService.on();
                });
                this.on('complete', function (file) {
                    self.loadingService.off();
                });
            },
            success: function (file, responseText, e) {
                if (file.xhr) {
                    self.api.checkBuildNoStr(file.xhr.getResponseHeader('x-pg-spa-buildno'));
                }
                if (responseText.url) {
                    if (responseText.url && responseText.url.match(/(.+\/)(.+?)$/)) {
                        self.path = RegExp.$1;
                        self.uploadFileName = RegExp.$2;
                    }
                    self.fileName = self.uploadFileKey ? file.name : self.uploadFileName;
                    self.displayFileName = self.type === "auto" /* auto */ ? file.upload_filename : file.name;
                }
                self.onChange();
                this.removeFile(file);
            },
            error: function (file, message) {
                if (file.xhr) {
                    var checkBuildNo = self.api.checkBuildNoStr(file.xhr.getResponseHeader('x-pg-spa-buildno'));
                    if (checkBuildNo && file.xhr.status === 401) {
                        self.api.onUnauthorized(message);
                    }
                }
                if (file.previewElement) {
                    file.previewElement.classList.add('dz-error');
                    file.previewElement.querySelector('.dz-error-message').style['white-space'] = 'pre-wrap';
                    file.previewElement.querySelector('.dz-error-message').style['top'] = '140px';
                    if (typeof message !== 'string' && message.message) {
                        message = message.message;
                    }
                    file.previewElement.querySelector('[data-dz-errormessage]').textContent = message;
                }
            }
        });
    };
    FileComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        var file = this.fileService.getFile(this.componentName, this.baseService.getColKey(this.componentName, this.col.key, this.index));
        if (changes.col) {
            var fileName = (this.col.params && this.col.params.fileName ? this.col.params.fileName : {});
            this.selectType = fileName.selectType || false;
            this.type = file.type || fileName.type || "auto" /* auto */;
            this.nameTypeKey = fileName.nameTypeKey || null;
            this.uploadFileKey = fileName.uploadFileKey || null;
            this.displayFileKey = fileName.displayFileKey || null;
        }
        else {
            this.type = file.type;
        }
        if (changes.displayFile && this.displayFileKey) {
            this.displayFileName = this.displayFile;
        }
        if (changes.val) {
            if (this.val) {
                if ((!file.url || this.val !== file.url) && this.val && this.val.match(/(.+\/)(.+\..+)$/)) {
                    this.path = RegExp.$1;
                    this.fileName = RegExp.$2;
                    this.uploadFileName = RegExp.$2;
                }
                else {
                    this.path = file.path;
                    this.fileName = file.fileName;
                    this.uploadFileName = file.uploadFileName;
                }
            }
            else {
                this.path = null;
                this.fileName = null;
                this.uploadFileName = null;
            }
            this.getFileOption(this.val);
            this.setFile(this.val);
        }
    };
    FileComponent.prototype.getFileOption = function (url) {
        this.fileOption = this.fileService.getFileOption(url, this.col.params);
    };
    FileComponent.prototype.remove = function () {
        this.path = null;
        this.fileName = null;
        this.uploadFileName = null;
        this.displayFileName = null;
        _super.prototype.onChange.call(this, null);
        this.getFileOption(null);
        this.setFile(null);
    };
    FileComponent.prototype.onChange = function () {
        var url = '';
        if (this.type === "auto" /* auto */) {
            url = this.path + this.uploadFileName;
        }
        else {
            url = this.path + this.fileName;
        }
        _super.prototype.onChange.call(this, url);
        this.getFileOption(url);
        this.setFile(url);
    };
    FileComponent.prototype.onChangeFileNameType = function (e) {
        this.type = e.val;
        this.onChange();
    };
    FileComponent.prototype.onChangeFileName = function (e) {
        this.fileName = e.val;
        this.onChange();
    };
    FileComponent.prototype.setFile = function (url) {
        this.fileService.setFile(this.componentName, this.baseService.getColKey(this.componentName, this.col.key, this.index), {
            type: this.type,
            url: url,
            path: this.path,
            fileName: this.fileName,
            uploadFileName: this.uploadFileName
        });
        if (!this.col.readonly) {
            if (this.nameTypeKey) {
                this.changeVal.emit({ key: this.nameTypeKey, val: this.type });
            }
            if (this.uploadFileKey) {
                this.changeVal.emit({ key: this.uploadFileKey, val: this.uploadFileName });
            }
            if (this.displayFileKey) {
                this.changeVal.emit({ key: this.displayFileKey, val: this.displayFileName });
            }
        }
    };
    FileComponent.prototype.checkVal = function () {
        if (this.col.required && !this.service.checkVal(this.val)) {
            return [this.msg['ColumnComponent.error.required']];
        }
        return [];
    };
    FileComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.element) {
            Dropzone.forElement(this.element).destroy();
        }
    };
    FileComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-file',
                    template: "<div [key]=\"key\" [col]=\"col\" columnDir></div>\n<ul>\n  <ng-template [ngIf]=\"val && col.params?.displayUrl !== false\">\n    <ng-template [ngIf]=\"selectType && !col.readonly\">\n      <li class=\"form_li form_li-break\">\n        <column-radio [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n          key: col.key + '-fileNameType',\n          controlType: 'radio',\n          required: true,\n          params: {\n            options: [\n              {code: 'auto', display: msg['au.COMPONENT.FileComponent.radio.auto']},\n              {code: 'manual', display: msg['au.COMPONENT.FileComponent.radio.manual']}\n            ]\n          }\n        }\" [val]=\"type\" [msg]=\"msg\" (changeVal)=\"onChangeFileNameType($event)\"></column-radio>\n      </li>\n    </ng-template>\n    <ng-template [ngIf]=\"type === 'auto'\">\n      <!--\n      <li *ngIf=\"col.params?.displayPath !== false\" class=\"form_li\">\n        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"val\"></column-formlabel>\n      </li>\n      <li *ngIf=\"col.params?.displayPath === false\" class=\"form_li\">\n        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"uploadFileName\"></column-formlabel>\n      </li>\n      -->\n      <li class=\"form_li\">\n        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"uploadFileName\"></column-formlabel>\n      </li>\n    </ng-template>\n    <ng-template [ngIf]=\"type === 'manual'\">\n      <!--\n      <li *ngIf=\"col.params?.displayPath !== false && !col.readonly\" class=\"form_li\">\n        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"path\"></column-formlabel>\n      </li>\n      <li *ngIf=\"col.params?.displayPath !== false && col.readonly\" class=\"form_li\">\n        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"val\"></column-formlabel>\n      </li>\n      <li *ngIf=\"col.params?.displayPath === false && col.readonly\" class=\"form_li\">\n        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"fileName\"></column-formlabel>\n      </li>\n      -->\n      <li class=\"form_li\">\n        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"displayFileName\"></column-formlabel>\n      </li>\n<!--      <li class=\"form_li\">-->\n<!--        <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"{key: col.key + '-fileName', controlType: 'text', required: true, params: {formClass: {width: '300'}}}\" [val]=\"displayFileName\"></column-formlabel>-->\n<!--      </li>-->\n<!--      <li *ngIf=\"!col.readonly\" class=\"form_li\">-->\n<!--        <column-text [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"index\"-->\n<!--                     [col]=\"{key: col.key + '-fileName', controlType: 'text', required: true}\"-->\n<!--                     [val]=\"fileName\"-->\n<!--                     [msg]=\"msg\" (changeVal)=\"onChangeFileName($event)\"></column-text>-->\n<!--      </li>-->\n    </ng-template>\n    <li *ngIf=\"col?.params?.copy === true\" class=\"form_li\">\n      <column-copy [key]=\"key\" [col]=\"col\" [val]=\"val\" [msg]=\"msg\"></column-copy>\n    </li>\n  </ng-template>\n  <li class=\"form_li form_li-break\">\n    <div *ngIf=\"val\" class=\"formDadUploaded\">\n      <!--\n      <p *ngIf=\"fileOption.link === true\" class=\"formDadUploaded_content\">\n        <column-link [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n          label: 'File',\n          key: col.key + '-link',\n          controlType: 'link',\n          params: {assets: true, cache: false}\n        }\" [val]=\"path + uploadFileName\" [msg]=\"msg\"></column-link>\n        <column-img *ngIf=\"fileOption.icon\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n          key: col.key + '-img',\n          controlType: 'img',\n          params: {style: {height: '24px'}, cache: false}\n        }\" [val]=\"fileOption.icon\" [msg]=\"msg\"></column-img>\n      </p>\n      -->\n      <p class=\"-mb-05\" style=\"width: 120px;\">\n        <kts-column-file-download [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n          params: {\n            uuidFilePath: path + uploadFileName,\n            fileName: displayFileName,\n            assets: true,\n            cache: false\n          }\n        }\" [msg]=\"msg\"></kts-column-file-download>\n      </p>\n      <p *ngIf=\"fileOption.img === true\" class=\"formDadUploaded_content\">\n        <column-img [componentName]=\"componentName\" [index]=\"index\" [col]=\"{\n          key: col.key,\n          controlType: 'img',\n          params: {style: {maxHeight: '150px'}, cache: false}\n        }\" [val]=\"path + uploadFileName\" [msg]=\"msg\"></column-img>\n      </p>\n      <p *ngIf=\"!col.readonly\" class=\"-txtalnright -mb-05\">\n        <item-anchor [txt]=\"msg['au.COMPONENT.FileComponent.label.removeFile']\" (click)=\"remove()\"></item-anchor>\n      </p>\n    </div>\n    <div class=\"dropzone dz-clickable\" #file [style.display]=\"!col.readonly ? 'block': 'none'\">\n      <div class=\"dz-default dz-message\">{{ msg['au.COMPONENT.FileComponent.label.message'] }}</div>\n    </div>\n    <column-formreadonly *ngIf=\"col.readonly && !val\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"col\" [val]=\"val\" [msg]=\"msg\"></column-formreadonly>\n  </li>\n</ul>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FileComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: FileService },
        { type: ConfigService },
        { type: ApiService },
        { type: LoadingService }
    ]; };
    FileComponent.propDecorators = {
        displayFile: [{ type: Input }],
        fileElement: [{ type: ViewChild, args: ['file',] }]
    };
    return FileComponent;
}(ColumnBaseComponent));
export { FileComponent };
//# sourceMappingURL=file.component.js.map